// DownloadRecordedPassageDataRequest.
//
// Class representing a download recorded passage data request.
export class DownloadRecordedPassageDataRequest {
  public launchDate: Date;
  public receiveDate: Date;
  public uidList: number[];

  public constructor(launchDate: Date, receiveDate: Date, uidList: number[]) {
    this.launchDate = launchDate;
    this.receiveDate = receiveDate;
    this.uidList = uidList;
  }
}
